import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeOrderLocationModal, orderLocationAdd, openOrderNameModal, setNextModal } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalOrderLocation extends Component {

  // What happens when they hit the Dine In option
  handleDineIn = () => {
    this.props.orderLocationAdd('DINEIN');
    this.props.setNextModal(this.props.openOrderNameModal);
    this.props.closeOrderLocationModal();
  }

  // What happens when they hit the Takeout option
  handleTakeOut = () => {
    this.props.orderLocationAdd('TAKEOUT');
    this.props.setNextModal(this.props.openOrderNameModal);
    this.props.closeOrderLocationModal();
  }

  render() {
    return (
      <Modal show={this.props.modals.showOrderLocationModal} onHide={this.props.closeOrderLocationModal}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className="center-text">
            <div>
              <button type="button" onClick={event => this.handleDineIn()} className="btn btn-lg btn-primary">Is that for here?</button>
            </div>
            <div className="mt-1">
              <span className="h3 text-grey">OR</span>
            </div>
            <div className="mt-1">
              <button type="button" onClick={event => this.handleTakeOut()} className="btn btn-lg btn-primary">Would you like it to go?</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.props.closeOrderLocationModal}>Close</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals }) {
  return { modals };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeOrderLocationModal, orderLocationAdd, openOrderNameModal, setNextModal }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrderLocation);



// WEBPACK FOOTER //
// ./src/containers/modal_order_location.js